import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f1ef90b0&scoped=true"
import script from "./index?vue&type=script&lang=js&external"
export * from "./index?vue&type=script&lang=js&external"
import style0 from "./index.css?vue&type=style&index=0&id=f1ef90b0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ef90b0",
  null
  
)

export default component.exports